import { ComponentRendering, Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';

import { useMemo } from 'react';
import useHelpers from 'src/hooks/helpers';

const isComponentRendering = (o: any): o is ComponentRendering => 'componentName' in o;

const ContainerMain = ({ rendering }: ComponentProps): JSX.Element => {
  const placeholderName = Object.keys(rendering?.placeholders || {})[0] || 'abrdn-column';
  const { anchorId, backgroundClass, hasPlaceholders } = useHelpers(rendering);
  const cols = useMemo(() => {
    let cols = rendering?.params?.col || 'dynamic';
    const listOfSpecificComponents = {
      VectorTile: {
        breakPoints: {
          sm: 12,
          md: 12,
          xl: cols,
        },
      },
    };
    if (hasPlaceholders) {
      const childComponents = (placeholderName && rendering?.placeholders?.[placeholderName]) || [];
      childComponents.filter(isComponentRendering).forEach((component) => {
        const specificComponent = (listOfSpecificComponents as any)[component.componentName];
        if (specificComponent) {
          cols = specificComponent;
        }
      });
    }
    return cols;
  }, [rendering, hasPlaceholders, placeholderName]);

  const getColsClasses = useMemo(() => {
    if (typeof cols === 'object') {
      let returnedValue = '';
      Object.entries((cols as any).breakPoints).forEach((objectProperty) => {
        const key = objectProperty[0];
        const value = objectProperty[1] === 'dynamic' ? '' : objectProperty[1];
        returnedValue += `col-${key + (value ? '-' + value : '')} `;
      });
      return (returnedValue += 'd-flex flex-column');
    } else if (cols === 'dynamic') {
      return 'col-sm-12 col-md-6 col-xl d-flex flex-column';
    } else {
      const initialColsNumber = cols;
      const mdColsNumber = Number(initialColsNumber) < 6 ? 6 : initialColsNumber;
      return `col-md-${mdColsNumber} col-xl-${initialColsNumber} d-flex flex-column`;
    }
  }, [cols]);

  return (
    <section
      id={anchorId}
      data-e2e-component-uid={rendering.uid}
      className={`container-main ${backgroundClass}`}
    >
      <div className="container">
        <div className={`row ${hasPlaceholders && 'margin-top-row'}`}>
          {/*  Below is a workaround of wrapComponent function from legacy solution */}
          <Placeholder
            name={placeholderName}
            rendering={rendering}
            render={(components) => {
              return components.map((component, index) => (
                <div key={index} className={getColsClasses}>
                  {component}
                </div>
              ));
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default ContainerMain;
